import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'
import styled from '@emotion/styled'
import Img from 'gatsby-image'
import {device} from '../../devices'
import {TitleGradientHome} from '../title'
import {Text} from '../text'
import {ButtonGradient} from '../buttons/button'
import {GlobalContainer} from '../container/GlobalContainer'

export const Softwares = ({intl}) => {
  return (
    <Container>
      <ContainerTitle>
        <TitleGradientHome dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.title_info'})}}/>
        <Text dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.info_description'})}}/>
      </ContainerTitle>
      <ContainerInfo>
        <ContainerImg>
          <Image style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            zIndex: -1,
          }}/>
        </ContainerImg>
        <BlockRight>
          <Text dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.description'})}}/>
          <a href={`/en/#contact-us`}>
            <ButtonGradient>
              Talk with us
            </ButtonGradient>
          </a>
        </BlockRight>
      </ContainerInfo>
    </Container>
  )
}

const BlockRight = styled.div`
  display:flex;
  flex-direction: column;
  align-item: flex-start;
  justify-content: flex-start;
  
  button {
      width: 18vw;
      margin: 2vw 0 0 3.6vw;
  }
  
  @media ${device.mobileL} {
    justify-content: center;
    align-items: center;
    button {
      width: auto;
      margin: 2vw 0 0 0;
    }
    
    a {
        margin-top: 20px;
    }
    
    p {text-align:center;}
  }
`

const Image = ({style}) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "illus.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img style={{...style}} fluid={data.file.childImageSharp.fluid}/>
}

const ContainerInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  
  p {
    width: 20.508vw;
    margin-left: 3.6vw;
  }
  
  @media ${device.mobileL} {
    flex-direction: column;
    p {
      width: 90vw;
      margin-left: 0;
    }
  }
`

const Container = styled(GlobalContainer)`
  height: 57.617vw;
  
  @media ${device.mobileL} {
    height: auto;
    min-height: 100vh;
  }
`
const ContainerTitle = styled.div`
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 10vw 0 0 48.828vw;
  
  h2 {
    margin-bottom: 1.4vw;
  }
  
  @media ${device.mobileL} {
    margin: 53vw 0 0 0;
    h2 {
     margin-bottom: 30px;
    }
    br {display:none;}
    
    p {text-align: center;}
  }
`

const ContainerImg = styled.div`
  height: 32vw;
  width: 60vw;
  position:relative;
  
  @media ${device.mobileL} {
    height: 52vw;
    width: 95vw;
    margin: 50px 0;
  }
`

